import moment from 'moment';
import queryString from 'query-string';
import pickBy from 'lodash/pickBy';
import isEmpty from 'lodash/isEmpty';
import { DEFAULT_DATE_FORMAT } from 'common';
import { getAppConfigSetting, requests } from 'utils';
import { URL, SEARCH_LIMIT } from './constants';

export function parseSearchQueryParams(params = {}) {
  const searchParams = { page_size: SEARCH_LIMIT, ...params };
  // We need date time searches to include local utc offset
  const dateTimeFields = ['start_date', 'end_date'];
  dateTimeFields.forEach((field) => {
    if (field in searchParams) {
      const dt = moment(searchParams[field], DEFAULT_DATE_FORMAT);
      const isDaylightSavings = dt.isDST();
      if (dt.isValid()) {
        searchParams[field] = dt.utcOffset(moment().utcOffset(), isDaylightSavings).format();
      } else {
        delete searchParams[field];
      }
    }
  });

  // This is a manual hack to put state arg in comma format,
  // because querystring lib @5.x does not stringify arrays in comma format, which is required by the rest api.
  // This works in v6+, but our create-react-app version build script is incompatible.
  if (searchParams.state && typeof searchParams.state !== 'string') {
    let stateArg = '';
    searchParams.state.forEach((item) => {
      stateArg += `${item},`;
    });
    searchParams.state = stateArg;
  }
  // Strip out null/undefined values from query string.
  return queryString.stringify(
    pickBy(searchParams, (val) => !isEmpty(val)),
    { arrayFormat: 'comma' },
  );
}

export function searchRequest(params, headers) {
  const query = parseSearchQueryParams(params);
  return requests.get(`${URL(getAppConfigSetting('apiUrl'))}?${query}`, headers);
}



// WEBPACK FOOTER //
// ./src/services/search/api.js